(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-handball/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-handball/assets/javascripts/status.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_handball = svs.themes.sport_handball || {};
  var logger = new svs.core.log.Logger('svs.themes.sport_handball');

  svs.themes.sport_handball.matchNotice = function (match) {
    if (!match) {
      logger.warn('Invalid parameter to matchNotice, returning empty string.');
      return '';
    }

    var matchStatus;

    switch (match.status) {
      case 16:
        matchStatus = 'Väntar på förlängning';
        break;

      case 18:
        matchStatus = 'Väntar på straffläggning';
        break;

      case 24:
        matchStatus = 'Försenad matchstart';
        break;

      case 25:
        matchStatus = 'Inställd';
        break;

      case 26:
        matchStatus = 'Avbruten';
        break;

      case 28:
        matchStatus = 'Stoppad av domare';
        break;

      default:
        matchStatus = '';
        break;
    }

    return matchStatus;
  };

  svs.themes.sport_handball.isLive = function (status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    return !!_.contains([6, 7, 13, 14, 15, 16, 18, 19, 22], status);
  };

  svs.themes.sport_handball.isFinished = function (status) {
    return !!_.contains([31, 32, 33, 41], status);
  };

  svs.themes.sport_handball.isEnded = function (status) {
    return !!_.contains([25, 26, 28, 31, 32, 33, 41], status);
  }; 


  svs.themes.sport_handball.subscribeMatch = function (params) {
    return svs.themes.isDateHoursDiff(params.time, -4) && !svs.themes.sport_handball.isEnded(params.status);
  };

  svs.themes.sport_handball.hasStarted = function (status) {
    return status > 0 && !_.contains([23, 24, 25], status);
  };


  svs.themes.sport_handball.isFullTimeOrPassed = function (status, options) {
    options = _.extend({
      includeFullTime: true,
      includePauses: true,
      includeFinished: true
    }, options);
    var statusesForOvertimeOrPenalties = [19, 20, 21, 22];

    if (options.includeFullTime) {
      statusesForOvertimeOrPenalties.push(31, 41);
    }

    if (options.includePauses) {
      statusesForOvertimeOrPenalties.push(16, 17, 18);
    }

    if (options.includeFinished) {
      statusesForOvertimeOrPenalties.push(32, 33);
    }

    return _.contains(statusesForOvertimeOrPenalties, status);
  };


  svs.themes.sport_handball.getStatusText = function (options) {
    var text = '';
    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      getStartTime: true
    });
    var status = options.statusId;

    if (svs.themes.sport_handball.isLive(status)) {
      if (status === 6) {
        text = '1:A';
      } else if (status === 7) {
        text = '2:A';
      } else if (_.contains([14, 16, 18], status)) {
        text = 'PAUS';
      } else if (status === 15) {
        text = 'HT';
      }

      if (!text) {
        text = '1:A';
      }
    } else if (svs.themes.sport_handball.isEnded(status)) {
      if (status === 32) {
        text = 'ÖT';
      } else if (status === 33) {
        text = 'STR';
      } else {
        text = 'FT';
      }
    } else if (options.startTime && options.getStartTime) {
      text = svs.themes.formatTime(options.startTime);
    }

    return text;
  };
})(svs);
 })(window);